'use client'
import React from 'react'
import dummyImage from '../../../assets/images/app-download.png'
import MyImage from '../myImage'
import { useAddData } from '@/app/context/addsDataContext'
import { getBannerUrl, getImageUrl, isGetAdd } from '@/shared/utils'

function Ads({ height, width, className, params }: any) {
  const addData: any = useAddData()
  const isAdd = isGetAdd(params, addData)

  if (addData?.showAds && isAdd) {
    return (
      <a
        target="_blank"
        href={`${getBannerUrl(params, addData)}&utm_medium=${params}`}
        className="block"
        rel="noreferrer"
      >
        <MyImage
          alt="ads"
          className={`${className} rounded-lg`}
          src={getImageUrl(params, addData) || ''}
          placeholderImage={dummyImage}
          height={height}
          width={width}
        />
      </a>
    )
  } else return null
}

export default Ads
